import { Expose, Type } from "class-transformer";
import GenericTableResponse from "@/models/api/GenericTableResponse";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class DocumentItemToPair {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  purchaseNetPriceCurrency!: string;
  @IsOptional()
  @IsString()
  @Expose()
  pairAmountCurrency!: string | null;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  purchaseNetPrice!: number;
  @IsNumber()
  @Expose()
  purchaseNetPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  pairAmount!: number;
  @IsBoolean()
  @Expose()
  isPaired!: boolean;
  @IsBoolean()
  @Expose()
  writeOff!: boolean;
  @IsBoolean()
  @Expose()
  differentCurrencies!: boolean;
  @IsNumber()
  @Expose()
  costDocumentItemLeftPairAmount!: number;
  @IsNumber()
  @Expose()
  documentItemLeftPairAmount!: number;
}

export class DocumentItemsToPair extends GenericTableResponse<DocumentItemToPair> {
  @ValidateNested()
  @Type(() => DocumentItemToPair)
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<DocumentItemToPair>;
}
